export default __webpack_public_path__ + "static/media/affimob.081de4a0.svg";